import React, { useEffect, useState } from 'react';
import api from '../utils/axiosConfig';
import '../styles/CustomersPage.css';

export default function CustomersPage() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get('/backoffice/customers');
        if (data.success) {
          setCustomers(data.customers || []);
        }
      } catch { /* ignore */ }
      setLoading(false);
    })();
  }, []);

  const filtered = customers.filter((c) => {
    if (!search) return true;
    const q = search.toLowerCase();
    return (
      (c.full_name && c.full_name.toLowerCase().includes(q)) ||
      (c.phone && c.phone.includes(q))
    );
  });

  return (
    <div className="customers-page">
      <div className="customers-header">
        <h1>&#11088; العملاء</h1>
        <p className="customers-sub">قائمة جميع العملاء مع عدد الحجوزات</p>
      </div>

      <div className="customers-toolbar">
        <input
          type="text"
          className="search-input"
          placeholder="بحث بالاسم أو رقم الهاتف..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <div className="customers-total">
          {loading ? 'جاري التحميل...' : `${filtered.length} عميل`}
        </div>
      </div>

      {loading ? (
        <div className="customers-loading">جاري التحميل...</div>
      ) : filtered.length === 0 ? (
        <div className="customers-empty">
          <span className="empty-icon">&#128100;</span>
          <p>{search ? 'لا توجد نتائج للبحث' : 'لا يوجد عملاء بعد. أغلق يومًا من التقويم لبدء تتبع العملاء.'}</p>
        </div>
      ) : (
        <div className="customers-table-wrap">
          <table className="customers-table">
            <thead>
              <tr>
                <th>#</th>
                <th>اسم العميل</th>
                <th>رقم الهاتف</th>
                <th>عدد الحجوزات</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((c, i) => (
                <tr key={c.id}>
                  <td className="rank-cell">
                    {i < 3 ? (
                      <span className={`rank-badge rank-${i + 1}`}>{i + 1}</span>
                    ) : (
                      i + 1
                    )}
                  </td>
                  <td>{c.full_name || '—'}</td>
                  <td dir="ltr">{c.phone || '—'}</td>
                  <td>
                    <span className="count-badge">{c.reservation_count}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
